

(function($, B) {

    B.web.onReady['postview'] = function(){
        $('[data-widget="postlist"]').each(function(){
            var $postlist = $(this),
                o = $postlist.data('widgetOptions'),
                // $filter = $(filterSelector),
                $filter = $postlist.find(o.filter),
                $items = $postlist.find(o.items),
                $pagination = $postlist.find(o.pagination),
                $info = $postlist.find(o.info),
                // filterSelector = '[data-filter="#' + $postlist.attr('id') + '"]',
                tmpl_item = $postlist.data('tmpl-item'),
                ajaxParams = {
                    post_type : o.postType,
                    offset: 0,
                    filters: {}
                };
            
            var _displayPosts=function(posts){
                    $items.empty();
                    for(var i in posts){
                        var $item = $(tmpl_item).fill(posts[i]);
                        $items.append($item);
                    }
                },
                _displayInfo = function(data){
                    $info.empty();
                    $info.append('<strong>Znaleziono</strong><span class="p-2"> ' + data.all + '</span>');
                },
                _displayPagination = function(data){
                    var lpag = Math.ceil(data.all / data.number),
                        actual = Math.floor(data.offset/data.number),
                        $buttons = $('<div class="btn-group btn-group-toggle" data-toggle="buttons"></div>');
                    var _createButton=function(options){
                        var $btn = $('<button type="button" class="btn btn-outline-dark"></button>');
                        if(options.disabled){
                            $btn.attr('disabled', 'disabled');
                        }
                        if(options.active){
                            $btn.addClass('active');
                        }
                        $btn.data(options.data);
                        $btn.html(options.content);
                        return $btn;
                    };
                    $pagination.empty();
                    $pagination.append($buttons);
                    $buttons.append(_createButton({
                        disabled : data.offset < data.number,
                        content: '<<',
                        data: {
                            offset: data.offset > data.number ? (actual-1)*data.number : 0 
                        }
                    }));
                    for(var i = 0; i<lpag; i++){
                        $buttons.append(_createButton({                           
                            active : i == actual,
                            content: i+1,
                            data: {
                                offset: i*data.number
                            }   
                        }));
    
                    }
                    $buttons.append(_createButton({
                        disabled : actual+1 == lpag,
                        content: '>>',
                        data: {
                            offset: (actual+1)*data.number
                        }   

                    }));

                };
            


            var _refetchPosts = function(){
                $.ajax({
                    type : 'GET',
                    url: siteAJAX.url + 'rest/' + o.postType + '/get_preview_list',       
                    data: ajaxParams,
                    beforeSend:function(jqXHR, settings ){
                        jqXHR.setRequestHeader( 'X-WP-Nounce', siteAJAX.nounce);
                    },
                    success: function ( data, textStatus, jqXHR ) {
                        _displayPosts(data.data.posts);
                        _displayInfo(data.data);
                        _displayPagination(data.data);
                    },
                    error: function(jqXHR, textStatus, errorThrown ){
                        console.log('error ajax');
                    }
                });   
            };
        
            $filter.on('changed',function(e, data){
                ajaxParams.filters = data || {};
                ajaxParams.offset = 0;
                _refetchPosts();
            });
        
            $pagination.on('click', 'button', function(e){
                var $btn = $(e.target),
                    o = $btn.data();
                ajaxParams.offset = o.offset;
                _refetchPosts();
            });
    
            ajaxParams.filters = B.filter.read($filter);
            _refetchPosts();
    
        });
    };   

    B.web.onReady['postselect'] = function(){
        $(function(){
            $('[data-widget="postselect"]').each(function(){
                var $postselect = $(this),
                    o = $postselect.data('widgetOptions'),
                    $filter = $postselect.find(o.filter),
                    $select = $postselect.find(o.select),
                    $items = $postselect.find(o.items),
                    ajaxParams = $.extend(true, {
                        post_type : o.postType,
                        filters: {}
                    }, o.ajaxParams || {} );
                
                var _displayPosts=function(posts){
                        $items.empty();
                        for(var i in posts){
                            $items.append('<option value="' + posts[i].ID + '">' + B.convert(posts[i].post_date, 'date') + ' - ' + posts[i].post_title + '</option>');
                        }
                    };
                


                var _refetchPosts = function(){
                    $.ajax({
                        type : 'GET',
                        url: siteAJAX.url + 'rest/' + o.postType + '/get_preview_list',       
                        data: ajaxParams,
                        beforeSend:function(jqXHR, settings ){
                            jqXHR.setRequestHeader( 'X-WP-Nounce', siteAJAX.nounce);
                        },
                        success: function ( data, textStatus, jqXHR ) {
                            _displayPosts(data.data.posts);
                        },
                        error: function(jqXHR, textStatus, errorThrown ){
                            console.log('error ajax');
                        }
                    });   
                };
            
                $filter.on('changed',function(e, data){
                    ajaxParams.filters = data || {};
                    _refetchPosts();
                });
            
                ajaxParams.filters = B.filter.read($filter);
                _refetchPosts();
        
            });
        
        });
    };

})(jQuery, Bajt);

